var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Nummer bearbeiten"}},[_c('emergency-number-form',{attrs:{"loading":_vm.loading,"number":_vm.number,"form-submitted":_vm.saveNumber,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }